import { render, staticRenderFns } from "./FStatesCom.vue?vue&type=template&id=1a20c49a"
import script from "./FStatesCom.vue?vue&type=script&lang=js"
export * from "./FStatesCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports